Not done yet
<div class="card my-3">
  <div class="card-body">
    <h5 class="card-title align-items-center d-block d-md-flex justify-content-between">
      <div class="mb-2 mb-md-0"><i class="mr-2 text-primary fs-28" [ngClass]="activity.icon"></i>{{ activity.title }}</div>
      <common-status-label [status]="activity.status" labelStyle="status-pill"></common-status-label>
    </h5>
    <p class="card-text font-weight-light" [innerHtml]="activity.description"></p>
  </div>
</div>
